import {Modal, Form, Input, Button, message} from "antd";
import React, {useState, useEffect} from "react";
import PasswordUtil from "../../../util/PasswordUtil";
import PasswordService from "../../../service/plt/PasswordService";
import NoAuthPasswordService from "../../../service/noAuth/plt/NoAuthPasswordService";
import AppContext from "../../../application/AppContext";

function PasswordSettingModal({onCancel}) {
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [passwordConfig, setPasswordConfig] = useState();

    const getPasswordConfig = async () => {
        const config = await NoAuthPasswordService.getConfigAsync({
            hospitalId: AppContext.user.hospital.id,
        });
        setPasswordConfig(config);
    };

    useEffect(() => {
        getPasswordConfig();
    }, []);


    const getNewPasswordError = (newPassword) => {
        if (!newPassword) {
            return "请输入新密码";
        }
        if (newPassword.length < passwordConfig.passwordLength) {
            return `密码长度不能短于${passwordConfig.passwordLength}位`;
        }
        if (passwordConfig.includeLetter && (!/[a-z]/.test(newPassword) || !/[A-Z]/.test(newPassword))) {
            return "密码必须同时包含大小写字母";
        }
        if (passwordConfig.includeDigit && !/\d/.test(newPassword)) {
            return "密码必须包含数字";
        }
        return null;
    };
    const validateNewPassword = (_, value) => {
        const error = getNewPasswordError(value);
        return error ? Promise.reject(new Error(error)) : Promise.resolve();
    };
    const validateConfirmPassword = ({getFieldValue}) => ({
        validator(_, value) {
            if (!value) {
                return Promise.reject(new Error("请再次输入新密码"));
            }
            if (value !== getFieldValue("newPassword")) {
                return Promise.reject(new Error("两次输入的新密码不一致"));
            }
            return Promise.resolve();
        },
    });

    const submitChangePassword = async () => {
        const values = await form.validateFields();
        try {
            setIsLoading(true);
            await PasswordService.updateAsync({
                userId: AppContext.user.id,
                oldPassword: PasswordUtil.hash(values.oldPassword),
                newPassword: PasswordUtil.hash(values.newPassword),
            });
            message.success("修改成功");
            const newPathName = `${_.chain(location.pathname)
                .split("/")
                .slice(1)
                .dropRight(1)
                .join("/")
                .value()}/accountlogin.html`;
            const url = new URL(newPathName, location.origin);
            url.searchParams.set("hospitalId", AppContext.user.hospital.id);
            location.replace(url.toString());
            onCancel();
        } finally {
            setIsLoading(false);
        }
    };

    const renderPasswordInput = ({
        label, name, placeholder, autoComplete, rules,
    }) => {
        return (
            <Form.Item
                label={label}
                name={name}
                rules={rules}
            >
                <Input.Password
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                />
            </Form.Item>
        );
    };


    return (
        <Modal
            title="密码设置"
            visible
            onCancel={onCancel}
            onOk={submitChangePassword}
            okButtonProps={{
                loading: isLoading,
            }}
        >
            <Form
                form={form}
                labelCol={{span: 4}}
                wrapperCol={{span: 20}}
                colon={false}
                requiredMark={false}
            >
                {
                    renderPasswordInput({
                        label: "原密码",
                        name: "oldPassword",
                        placeholder: "请输入原密码",
                        autoComplete: "current-password",
                        rules: [{required: true, message: "请输入原密码"}],
                    })
                    }
                {renderPasswordInput({
                    label: "新密码",
                    name: "newPassword",
                    placeholder: "请输入新密码",
                    autoComplete: "new-password",
                    rules: [{validator: validateNewPassword}],
                })}
                {renderPasswordInput({
                    label: "确认新密码",
                    name: "confirmPassword",
                    placeholder: "请再次输入新密码",
                    autoComplete: "new-password",
                    rules: [validateConfirmPassword],
                })}
            </Form>
            
        </Modal>
    );
}


export default PasswordSettingModal;
